import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

const IdCardViewer = ({ fileName, folderName }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const token = JSON.parse(localStorage.getItem("loginDetails"))?.token;

  const fetchPdf = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEV_IMG_URL}${folderName}/${fileName}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch PDF");

      const blob = await response.blob();
      const pdfBlob = new Blob([blob], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(`${blobUrl}`);
    } catch (error) {
      console.error("Error fetching ID card PDF:", error);
    }
  };

  useEffect(() => {
    if (fileName && folderName) {
      fetchPdf();
    }
  }, [fileName, folderName]);

  return (
    <Box
      sx={{
        width: 300,
        height: 500,
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <iframe
        src={pdfUrl}
        width="100%"
        height="100%"
        title="ID Card"
        style={{ border: "none" }}
      />
    </Box>
  );
};

export default IdCardViewer;
